import React from "react";
import { SuppressionInfoView } from "@tiny/api";
import { DataTable, Typography } from "@tiny/components";
import { SuppressionTableProps } from "./SuppressionTable.types";
import { useSuppressionTable } from "./SuppressionTable.hooks";

function SuppressionTable(props: SuppressionTableProps) {
  const {
    allSelected,
    enableEdit,
    onToggleSelect,
    onToggleSelectAll,
    selected,
    suppressions,
  } = props;

  const { moreActions, mdUp } = useSuppressionTable(props);
  const columns = [
    {
      id: "Email",
      renderBody: (item: SuppressionInfoView) => (
        <Typography variant="body3" color="primary" tone="main" noWrap>
          {item.value}
        </Typography>
      ),
      header: "Email",
      width: "40%",
    },
    {
      id: "description",
      renderBody: (item: SuppressionInfoView) =>
        item?.description ? item?.description : "",
      header: "Description",
      width: "40%",
    },
  ];

  const renderWrapper = React.useCallback((content: React.ReactNode) => {
    return (
      <Typography variant="body3" color="grey" tone={700} noWrap>
        {content}
      </Typography>
    );
  }, []);

  return (
    <>
      {suppressions.length > 0 && (
        <DataTable
          idKey="id"
          columns={columns}
          data={suppressions}
          moreActions={moreActions}
          selected={selected}
          enableEdit={enableEdit}
          renderBodyWrapper={renderWrapper}
          renderHeadWrapper={renderWrapper}
          onToggleSelect={onToggleSelect}
          allSelected={allSelected}
          onToggleSelectAll={onToggleSelectAll}
          size="small"
          allowPan
          sidePadding={mdUp ? 8 : 6}
          headerBg="#FBFCFD"
          showBorderTop
          hideCheckbox={true}
        />
      )}
    </>
  );
}

export default SuppressionTable;
